
import { defineComponent, PropType } from "vue";

export default defineComponent({
   emits: ["update:modelValue"],
   props: {
      /**
       * @param {Array} list 数据列表
       */
      list: {
         type: Array as PropType<any[]>,
         default: (): any[] => [],
      },

      /**
       * @param {Object} prop 可选参数
       */
      prop: {
         type: Object as PropType<any>,
         default: (): any => {
            return {
               label: "label",
               id: "id",
            };
         },
      },

      /**
       *@param {String, Number]} width 列表宽度
       */
      width: {
         type: [String, Number],
         default: "279px",
      },

      /**
       * 选中值
       */
      modelValue: {
         type: [String, Number],
         default: "",
      },
   },
   setup(props, context) {
      const rowClick = (row: any) => {
         context.emit("update:modelValue", row[props.prop.id]);
      };
      return {
         rowClick,
      };
   },
});
